import { Select, SelectProps } from '@makyoapp/makyo-tw-ui'

export type CompSelectProps = SelectProps

/**
 * CompSelectCore
 */
export const CompSelectCore = Select
